import React, { useContext, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@state/actions';
import selectors from '@state/selectors';
import {IProps} from './types';
import C from '@assets/themes/colors';
import * as S from './styles';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
const uuid = require('react-uuid');

const FolderEdit:React.FC<IProps> = (props) => {
  const dispatch = useDispatch();
  const authContext = useContext(AuthContext);
  const [value, setValue] = useState(props.value ? props.value : "" );
  const [tipLabel, setTipLabel] = useState("");
  const [isChecking, setIsChecking] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [userData, setUserData] = useState({
    email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
    name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
  });

  const folders = useSelector(selectors.folders.getFolders);

  const addFolder = (folder: any) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.folders.addFolder(folder, (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }))
    })
  } 

  const updateFolder = (folder: any) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.folders.updateFolder(folder, (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }))
    })
  }

  const handleChangeName = (e : any) => {
    setValue(e.target.value);
    validateFolderName(e.target.value);
  }

  const validateFolderName = async (name: string) => {
    let valid = false;
    name = name.replace(/  +/g, ' ').trim();

    if (name.toLowerCase()==="all my designs" || name.toLowerCase()==="favorites") setTipLabel("ERROR: This name can not be used");
    else if (folders?.length > 0 && folders[0].folders?.length > 0) {
        valid = true;
        
        folders[0].folders.forEach(function (item: any) {
          if (props.edit) {
            if (props.value!==name && item.name.toLowerCase()===name.toLowerCase()) valid = false;
          }
          else if (item.name.toLowerCase()===name.toLowerCase()) valid = false;
        });
        
        if (!valid) setTipLabel("ERROR: Name needs to be unique");
    }
    else{
      valid = true;
    }

    if (valid) setTipLabel("");
  }
  
  const handleKeyUp=(e:any)=>{
    if (e.keyCode === 13) saveFolder();
  }

  const handleOnBlur = () => saveFolder();

  const saveFolder = async() => {
    if (value.length>0 && tipLabel.length===0 && !isSaving){
      if (props.onAction && tipLabel.length===0) props.onAction(false);
      setIsSaving(true);
      let foldersUser = folders;
      
      if (foldersUser && foldersUser.length===0 && !props.edit){
        foldersUser = {
          id: uuid(),
          createdBy: userData,
          folders: [{ id: uuid(),name: value, counter: 0 } ]
        }
        const saveFolder :any = await addFolder(foldersUser);
      } else {
        if (props.edit) {
          if (value!==props.value){
            foldersUser[0].folders = foldersUser[0].folders.map( (folder:any) => {
              if (props.value===folder.name) folder.name = value
              return folder;
            });
            const saveFolder :any = await updateFolder(foldersUser[0]);
          }
        } else {
          foldersUser[0].folders.push( { id: uuid(),name: value, counter: 0 } );
          const saveFolder :any = await updateFolder(foldersUser[0]);
        }
      }
      setIsSaving(false);
    } if (!props.edit && props.onAction) props.onAction(false);
  }
  
  return (
    <S.Root>
        <S.InputNameFolder  
            id="name"
            autoFocus
            placeholder="Enter Folder Name"
            value={value}
            onChange={handleChangeName}
            onKeyUp={(e)=>handleKeyUp(e)} 
            onBlur={(e)=>handleOnBlur()}
            autoComplete="off"
          />
          {
            tipLabel !== "" &&
            <S.TipLabel textColor={isChecking ? '#8891a0' : C.RED}>
              {tipLabel}
            </S.TipLabel>
          }
    </S.Root>
  );
}

export default FolderEdit;